<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Solicitar Visita</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestVisit">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column">
            <b-field
              :label="request.eventInfo.eventName ? 'Nome do evento' : ''"
              label-position="on-border"
            >
              <b-input
                v-model="request.eventInfo.eventName"
                placeholder="Nome do evento"
              ></b-input>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="request.eventInfo.attendeeQty ? 'Público estimado *' : ''"
              label-position="on-border"
            >
              <b-input
                type="number"
                placeholder="Público estimado *"
                v-model="request.eventInfo.attendeeQty"
              ></b-input>
            </b-field>
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.studentsCourses.length
              ? 'Cursos dos estudantes *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.studentsCourses"
            :data="coursesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Cursos dos estudantes *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <date-options />

        <b-field
          :label="request.eventInfo.plant ? 'Planta que deseja visitar *' : ''"
          label-position="on-border"
        >
          <b-select
            expanded
            v-model="request.eventInfo.plant"
            placeholder="Selecione uma planta"
            @input="plantFormat"
          >
            <option value="">Selecione uma planta</option>
            <option
              v-for="(plant, index) in plants"
              :key="index"
              :value="plant.name"
            >
              {{ `${plant.name} | ${plant.city}, ${plant.state}` }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Tipo de visita" v-if="request.eventInfo.plant">
          <b-radio
            v-model="request.eventInfo.isOnline"
            :native-value="true"
            type="is-primary"
            :disabled="hasFormat"
          >
            <span>Online</span>
          </b-radio>

          <b-radio
            v-model="request.eventInfo.isOnline"
            :native-value="false"
            type="is-primary"
            :disabled="hasFormat"
          >
            <span>Presencial</span>
          </b-radio>
          <span @click="formatAlert" v-if="hasFormat">
            <b-icon
              type="is-info"
              icon="info-circle"
              class="format-icon"
            ></b-icon>
          </span>
        </b-field>

        <b-field label="Se desejar, anexe um material de suporte em PDF">
          <b-field>
            <div class="columns">
              <div class="column is-narrow">
                <button
                  type="button"
                  class="button is-empower-gray"
                  @click="$refs.pdf_visit.click()"
                >
                  Anexar PDF (max. 5mb)
                </button>
                <input
                  id="pdf_visit"
                  type="file"
                  ref="pdf_visit"
                  style="display: none"
                  @change="handleFileUpload()"
                />
              </div>

              <div class="column">
                <p
                  v-if="filename"
                  :style="[!isMobile ? { 'margin-top': '0.4rem' } : null]"
                >
                  ✅ {{ filename }}&nbsp;
                  <a class="delete is-medium" @click="excludeFile"></a>
                </p>
              </div>
            </div>
          </b-field>
        </b-field>

        <b-field
          :label="request.organizationComments ? 'Algum comentário?' : ''"
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Algum comentário?"
            v-model="request.organizationComments"
          />
        </b-field>

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey "
        >
          <div class="field">
            <b-checkbox v-model="terms.form">
              Aceito enviar o formulário disponibilizado pela Empower a todos os
              participantes da ação.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos da visita e coletar as devidas
              autorizações para uso de imagem dos participantes que aparecerem
              nos prints/fotos enviados.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin da OE.
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            class="button is-primary"
            :disabled="pendencies.length || isLoading"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Visita
          </button>
        </div>

        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { cursos } from "../../../assets/js/cursos";
import dateOptions from "./date-time-options/DateOptions";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive],

  components: {
    dateOptions,
    Pendencies,
  },

  props: ["advance"],

  data() {
    const today = new Date();
    return {
      minDate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + this.advance * 7
      ),
      isLoading: false,
      hasFormat: false,
      plants: [{}],
      request: {
        opportunity: null,
        requestType: "visit",
        eventInfo: {
          eventName: "",
          plant: "",
          isOnline: "",
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null
            },
            second: {
              date: null,
              start: null,
              end: null
            },
            third: {
              date: null,
              start: null,
              end: null
            }
          },
          attendeeQty: null,
          studentsCourses: []
        },
        organizationComments: "",
      },

      pdf_visit: "",
      filename: "",
      terms: {
        form: false,
        photos: false,
        post: false,
      },
      coursesArray: []
    };
  },

  methods: {
    handleFileUpload() {
      this.filename = this.$refs.pdf_visit.files[0].name;
      this.pdf_visit = this.$refs.pdf_visit.files[0];
    },

    excludeFile() {
      this.filename = "";
      this.pdf_lecture = "";
    },

    requestVisit() {
      if (this.pdf_visit.size > 5000000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE" });
        return;
      }

      this.request.eventInfo.dateOptions.first.start =
        this.request.eventInfo.dateOptions.first.date;
      this.request.eventInfo.dateOptions.first.end =
        this.request.eventInfo.dateOptions.first.date;

      this.request.eventInfo.dateOptions.second.start =
        this.request.eventInfo.dateOptions.second.date;
      this.request.eventInfo.dateOptions.second.end =
        this.request.eventInfo.dateOptions.second.date;

      this.request.eventInfo.dateOptions.third.start =
        this.request.eventInfo.dateOptions.third.date;
      this.request.eventInfo.dateOptions.third.end =
        this.request.eventInfo.dateOptions.third.date;

      let formData = new FormData();
      formData.append("pdf_visit", this.pdf_visit);
      formData.append("request", JSON.stringify(this.request));

      this.isLoading = true;
      this.$store
        .dispatch("makeRequest", {
          to: "visit",
          data: formData,
        })
        .then((res) => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação de Visita Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close(),
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setActivePlants() {
      let j = 0;
      for (let i = 0; i < this.opportunityBeingVisited.plants.length; i++)
        if (this.opportunityBeingVisited.plants[i].visitIsActive)
          this.plants[j++] = this.opportunityBeingVisited.plants[i];
    },

    plantFormat() {
      if (this.request.eventInfo.plant) {
        var plant = this.plants.find(
          (p) => p.name == this.request.eventInfo.plant
        );
        if (plant.format == "online") {
          this.request.eventInfo.isOnline = true;
          this.hasFormat = true;
        } else if (plant.format == "faceToFace") {
          this.request.eventInfo.isOnline = false;
          this.hasFormat = true;
        } else {
          this.request.eventInfo.isOnline = "";
          this.hasFormat = false;
        }
      } else {
        this.request.eventInfo.isOnline = "";
        this.hasFormat = false;
      }
    },

    formatAlert() {
      this.$buefy.dialog.alert(
        "Esta planta aceita visitas apenas neste formato."
      );
    },
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"]),

    pendencies() {
      const pendencies = [];

      if (!this.terms.form || !this.terms.photos || !this.terms.post) {
        pendencies.push("Aceitar os termos de contrapartidas");
      }

      if (this.request.eventInfo.isOnline === "") {
        pendencies.push("Tipo da Visita");
      }

      if (this.request.eventInfo.studentsCourses.length < 1) {
        pendencies.push("Informe os cursos dos estudantes");
      }

      if (!this.request.eventInfo.eventName) {
        pendencies.push("Nome do evento");
      }

      if (!this.request.eventInfo.attendeeQty) {
        pendencies.push("Público estimado");
      }

      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Primeira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.second.date) {
        pendencies.push("Segunda opção de data");
      }

      if (!this.request.eventInfo.dateOptions.third.date) {
        pendencies.push("Terceira opção de data");
      }

      if (!this.request.eventInfo.plant) {
        pendencies.push("Selecione uma planta");
      }

      return pendencies;
    },
  },

  created() {
    this.setActivePlants();
  },

  mounted() {
    this.coursesArray = cursos;
    
    this.request.opportunity = this.opportunityBeingVisited._id;
  },
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}

.format-icon {
  cursor: pointer;
}
</style>
